import React from 'react';

// Custom Excavator/Digger icon - depicts a tracked excavator with boom and bucket
const ExcavatorIcon = ({ className = "", size = 24, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      {/* Excavator cab/body */}
      <rect x="8" y="10" width="8" height="6" rx="1" />
      
      {/* Cab window */}
      <rect x="12" y="11" width="3" height="3" rx="0.5" />
      
      {/* Boom arm - first section */}
      <line x1="10" y1="10" x2="6" y2="5" />
      
      {/* Boom arm - second section (dipper) */}
      <line x1="6" y1="5" x2="3" y2="8" />
      
      {/* Bucket */}
      <path d="M3 8 L1 10 L3 12 L5 10 L3 8" />
      
      {/* Tracks - left */}
      <ellipse cx="6" cy="18" rx="4" ry="2" />
      
      {/* Tracks - right */}
      <ellipse cx="14" cy="18" rx="4" ry="2" />
      
      {/* Track connection to body */}
      <line x1="8" y1="16" x2="8" y2="17" />
      <line x1="16" y1="16" x2="16" y2="17" />
      
      {/* Counterweight */}
      <path d="M16 12 L19 12 L19 15 L16 15" />
    </svg>
  );
};

export default ExcavatorIcon;
